import {
  styled,
  DesignTokenSizeEnum,
  FullscreenLayer as VWGFullscreenLayer,
  type FullscreenLayerProps as VWGFullscreenLayerProps,
} from '@volkswagen-onehub/components-core';
import { PropsWithChildren } from 'react';
import useFullscreen from '@/hooks/useFullscreen';
import zIndex from '@/modules/constants/zIndex';
import Box from '../Box/Box';

export type FullscreenLayerProps = VWGFullscreenLayerProps &
  PropsWithChildren<{
    offsetTop?: keyof typeof DesignTokenSizeEnum;
  }>;

const StyledBox = styled.div`
  [class^='StyledFullscreenLayer-'] {
    z-index: ${zIndex.MODAL};
  }
`;

const FullscreenLayer = ({
  children,
  offsetTop = 'static650',
  ...restProps
}: FullscreenLayerProps) => {
  useFullscreen();

  return (
    <StyledBox>
      <VWGFullscreenLayer {...restProps}>
        <Box paddingTop={offsetTop} height="100%">
          {children}
        </Box>
      </VWGFullscreenLayer>
    </StyledBox>
  );
};

export default FullscreenLayer;
